// extracted by mini-css-extract-plugin
export default {"mobileShareIcon":"share_mobileShareIcon__nIpLi","sharebtn":"share_sharebtn__nNVC0","shareImg":"share_shareImg__bhiUW","shareLink":"share_shareLink__kEW9p"};